import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class OpenFileHelperService {
	private readonly _blobRevokeFallbackMs = 120000;

	openBlobInNewTab(data: BlobPart | Blob, mimeType?: string): boolean {
		if (!data) {
			return false;
		}

		const blob = data instanceof Blob ? data : new Blob([data as BlobPart], { type: mimeType ?? '' });
		const blobUrl = URL.createObjectURL(blob);

		const newWindow = window.open(blobUrl, '_blank', 'noopener,noreferrer');
		if (!newWindow) {
			URL.revokeObjectURL(blobUrl);
			return false;
		}

		setTimeout(() => URL.revokeObjectURL(blobUrl), this._blobRevokeFallbackMs);
		return true;
	}

	openUrlInNewTab(url: string): boolean {
		if (!url) {
			return false;
		}

		return !!window.open(url, '_blank', 'noopener,noreferrer');
	}
}
